import { render, staticRenderFns } from "./LeaderAutomaticQuestionnaireAnswer.vue?vue&type=template&id=c93d31b6&scoped=true&"
import script from "./LeaderAutomaticQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
export * from "./LeaderAutomaticQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderAutomaticQuestionnaireAnswer.vue?vue&type=style&index=0&id=c93d31b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93d31b6",
  null
  
)

export default component.exports